// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Decode_AsOption = require("bs-decode/src/Decode_AsOption.bs.js");
var Option$BsBastet = require("bs-bastet/bastet/src/Option.bs.js");
var Decode_ParseError = require("bs-decode/src/Decode_ParseError.bs.js");
var Relude_Extensions_Alt = require("relude/src/extensions/Relude_Extensions_Alt.bs.js");
var Decode_AsResult_OfParseError = require("bs-decode/src/Decode_AsResult_OfParseError.bs.js");

var isValidDate = (function isValidDate(date) {
      return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
    });

function infinityToMaxDate(json) {
  var positiveInfinity = Infinity;
  var maxDate = (new Date('3000-01-01'));
  if (json === positiveInfinity) {
    return Relude_Option.pure(maxDate);
  }
  
}

function negativeInfinityToMinDate(json) {
  var negativeInfinity = (-Infinity);
  var minDate = (new Date('0000-01-01'));
  if (json === negativeInfinity) {
    return Relude_Option.pure(minDate);
  }
  
}

var $less$pipe$great = Relude_Option.Infix.$less$pipe$great;

function toDate(maybeDate) {
  if (isValidDate(maybeDate)) {
    return Caml_option.some(maybeDate);
  }
  
}

function date(json) {
  return Curry._2($less$pipe$great, Curry._2($less$pipe$great, Curry._2($less$pipe$great, Curry._1(Decode_AsOption.date, json), toDate(json)), infinityToMaxDate(json)), negativeInfinityToMinDate(json));
}

var partial_arg = Curry._1(Relude_Option.flatMap, Relude_String.toInt);

function intFromString(param) {
  return Relude_Globals.$great$great(Decode_AsOption.string, partial_arg, param);
}

function intFromNumberOrString(json) {
  return Curry._2($less$pipe$great, Curry._1(Decode_AsOption.intFromNumber, json), Curry._1(intFromString, json));
}

var partial_arg$1 = Curry._1(Relude_Option.flatMap, Relude_String.toFloat);

function floatFromString(param) {
  return Relude_Globals.$great$great(Decode_AsOption.string, partial_arg$1, param);
}

function floatFromNumberOrString(json) {
  return Curry._2($less$pipe$great, Curry._1(Decode_AsOption.floatFromNumber, json), Curry._1(floatFromString, json));
}

function parseStringToJson(str) {
  try {
    return Relude_Option.some(JSON.parse(str));
  }
  catch (_exn){
    return ;
  }
}

var Option_SE = Relude_Option.Infix.SE;

var Option_$less$less$less = Relude_Option.Infix.$less$less$less;

var Option_$great$great$great = Relude_Option.Infix.$great$great$great;

var Option_FunctorExtensions = Relude_Option.Infix.FunctorExtensions;

var Option_$less$dollar$great = Relude_Option.Infix.$less$$great;

var Option_$less$hash$great = Relude_Option.Infix.$less$hash$great;

var Option_$less$dollar = Relude_Option.Infix.$less$;

var Option_$$great = Relude_Option.Infix.$$great;

var Option_$less$at$great = Relude_Option.Infix.$less$at$great;

var Option_ApplyExtensions = Relude_Option.Infix.ApplyExtensions;

var Option_$less$star$great = Relude_Option.Infix.$less$star$great;

var Option_$less$star = Relude_Option.Infix.$less$star;

var Option_$star$great = Relude_Option.Infix.$star$great;

var Option_MonadExtensions = Relude_Option.Infix.MonadExtensions;

var Option_$great$great$eq = Relude_Option.Infix.$great$great$eq;

var Option_$eq$less$less = Relude_Option.Infix.$eq$less$less;

var Option_$great$eq$great = Relude_Option.Infix.$great$eq$great;

var Option_$less$eq$less = Relude_Option.Infix.$less$eq$less;

var Option_$pipe$question = Relude_Option.Infix.$pipe$question;

var $$Option = {
  okJson: Decode_AsOption.okJson,
  $$boolean: Decode_AsOption.$$boolean,
  string: Decode_AsOption.string,
  floatFromNumber: Decode_AsOption.floatFromNumber,
  intFromNumber: Decode_AsOption.intFromNumber,
  variantFromJson: Decode_AsOption.variantFromJson,
  variantFromString: Decode_AsOption.variantFromString,
  variantFromInt: Decode_AsOption.variantFromInt,
  optional: Decode_AsOption.optional,
  array: Decode_AsOption.array,
  list: Decode_AsOption.list,
  tuple: Decode_AsOption.tuple,
  tupleAtLeast2: Decode_AsOption.tupleAtLeast2,
  tupleAtLeast3: Decode_AsOption.tupleAtLeast3,
  tupleAtLeast4: Decode_AsOption.tupleAtLeast4,
  tupleAtLeast5: Decode_AsOption.tupleAtLeast5,
  tupleFromFields: Decode_AsOption.tupleFromFields,
  dict: Decode_AsOption.dict,
  stringMap: Decode_AsOption.stringMap,
  at: Decode_AsOption.at,
  field: Decode_AsOption.field,
  optionalField: Decode_AsOption.optionalField,
  fallback: Decode_AsOption.fallback,
  oneOf: Decode_AsOption.oneOf,
  Pipeline: Decode_AsOption.Pipeline,
  compose: Relude_Option.compose,
  Semigroupoid: Relude_Option.Semigroupoid,
  andThen: Relude_Option.andThen,
  map: Relude_Option.map,
  Functor: Relude_Option.Functor,
  BsFunctorExtensions: Relude_Option.BsFunctorExtensions,
  flipMap: Relude_Option.flipMap,
  $$void: Relude_Option.$$void,
  voidRight: Relude_Option.voidRight,
  voidLeft: Relude_Option.voidLeft,
  flap: Relude_Option.flap,
  apply: Relude_Option.apply,
  Apply: Relude_Option.Apply,
  BsApplyExtensions: Relude_Option.BsApplyExtensions,
  applyFirst: Relude_Option.applyFirst,
  applySecond: Relude_Option.applySecond,
  map2: Relude_Option.map2,
  map3: Relude_Option.map3,
  map4: Relude_Option.map4,
  map5: Relude_Option.map5,
  tuple2: Relude_Option.tuple2,
  tuple3: Relude_Option.tuple3,
  tuple4: Relude_Option.tuple4,
  tuple5: Relude_Option.tuple5,
  mapTuple2: Relude_Option.mapTuple2,
  mapTuple3: Relude_Option.mapTuple3,
  mapTuple4: Relude_Option.mapTuple4,
  mapTuple5: Relude_Option.mapTuple5,
  pure: Relude_Option.pure,
  Applicative: Relude_Option.Applicative,
  BsApplicativeExtensions: Relude_Option.BsApplicativeExtensions,
  liftA1: Relude_Option.liftA1,
  bind: Relude_Option.bind,
  Monad: Relude_Option.Monad,
  BsMonadExtensions: Relude_Option.BsMonadExtensions,
  flatMap: Relude_Option.flatMap,
  flatten: Relude_Option.flatten,
  composeKleisli: Relude_Option.composeKleisli,
  flipComposeKleisli: Relude_Option.flipComposeKleisli,
  liftM1: Relude_Option.liftM1,
  when_: Relude_Option.when_,
  unless: Relude_Option.unless,
  align: Relude_Option.align,
  alignWith: Relude_Option.alignWith,
  Semialign: Relude_Option.Semialign,
  Align: Relude_Option.Align,
  foldLeft: Relude_Option.foldLeft,
  foldRight: Relude_Option.foldRight,
  Foldable: Relude_Option.Foldable,
  BsFoldableExtensions: Relude_Option.BsFoldableExtensions,
  any: Relude_Option.any,
  all: Relude_Option.all,
  containsBy: Relude_Option.containsBy,
  contains: Relude_Option.contains,
  indexOfBy: Relude_Option.indexOfBy,
  indexOf: Relude_Option.indexOf,
  minBy: Relude_Option.minBy,
  min: Relude_Option.min,
  maxBy: Relude_Option.maxBy,
  max: Relude_Option.max,
  countBy: Relude_Option.countBy,
  length: Relude_Option.length,
  size: Relude_Option.size,
  count: Relude_Option.count,
  forEach: Relude_Option.forEach,
  forEachWithIndex: Relude_Option.forEachWithIndex,
  find: Relude_Option.find,
  findWithIndex: Relude_Option.findWithIndex,
  toList: Relude_Option.toList,
  toArray: Relude_Option.toArray,
  FoldableSemigroupExtensions: Relude_Option.FoldableSemigroupExtensions,
  FoldableMonoidExtensions: Relude_Option.FoldableMonoidExtensions,
  foldMap: Relude_Option.foldMap,
  foldWithMonoid: Relude_Option.foldWithMonoid,
  intercalate: Relude_Option.intercalate,
  FoldableApplicativeExtensions: Relude_Option.FoldableApplicativeExtensions,
  FoldableMonadExtensions: Relude_Option.FoldableMonadExtensions,
  FoldableEqExtensions: Relude_Option.FoldableEqExtensions,
  FoldableOrdExtensions: Relude_Option.FoldableOrdExtensions,
  alt: Relude_Option.alt,
  altLazy: Relude_Option.altLazy,
  Semigroup_Any: Relude_Option.Semigroup_Any,
  Monoid_Any: Relude_Option.Monoid_Any,
  Alt: Relude_Option.Alt,
  Plus: Relude_Option.Plus,
  Alternative: Relude_Option.Alternative,
  Traversable: Relude_Option.Traversable,
  eqBy: Relude_Option.eqBy,
  eq: Relude_Option.eq,
  Eq: Relude_Option.Eq,
  Ord: Relude_Option.Ord,
  showBy: Relude_Option.showBy,
  show: Relude_Option.show,
  Show: Relude_Option.Show,
  WithSemigroup: Relude_Option.WithSemigroup,
  WithApplicative: Relude_Option.WithApplicative,
  some: Relude_Option.some,
  none: Relude_Option.none,
  empty: Relude_Option.empty,
  isSome: Relude_Option.isSome,
  isNone: Relude_Option.isNone,
  fold: Relude_Option.fold,
  foldLazy: Relude_Option.foldLazy,
  getOrElse: Relude_Option.getOrElse,
  getOrElseLazy: Relude_Option.getOrElseLazy,
  getOrThrow: Relude_Option.getOrThrow,
  orElse: Relude_Option.orElse,
  orElseLazy: Relude_Option.orElseLazy,
  tap: Relude_Option.tap,
  tapSome: Relude_Option.tapSome,
  tapNone: Relude_Option.tapNone,
  bitap: Relude_Option.bitap,
  filter: Relude_Option.filter,
  keep: Relude_Option.keep,
  filterNot: Relude_Option.filterNot,
  reject: Relude_Option.reject,
  OptionEqExtensions: Relude_Option.OptionEqExtensions,
  OptionOrdExtensions: Relude_Option.OptionOrdExtensions,
  $$String: Relude_Option.$$String,
  Int: Relude_Option.Int,
  Float: Relude_Option.Float,
  IO: Relude_Option.IO,
  Infix: Relude_Option.Infix,
  SE: Option_SE,
  $less$less$less: Option_$less$less$less,
  $great$great$great: Option_$great$great$great,
  FunctorExtensions: Option_FunctorExtensions,
  $less$$great: Option_$less$dollar$great,
  $less$hash$great: Option_$less$hash$great,
  $less$: Option_$less$dollar,
  $$great: Option_$$great,
  $less$at$great: Option_$less$at$great,
  $less$pipe$great: $less$pipe$great,
  ApplyExtensions: Option_ApplyExtensions,
  $less$star$great: Option_$less$star$great,
  $less$star: Option_$less$star,
  $star$great: Option_$star$great,
  MonadExtensions: Option_MonadExtensions,
  $great$great$eq: Option_$great$great$eq,
  $eq$less$less: Option_$eq$less$less,
  $great$eq$great: Option_$great$eq$great,
  $less$eq$less: Option_$less$eq$less,
  $pipe$question: Option_$pipe$question,
  toDate: toDate,
  date: date,
  intFromString: intFromString,
  intFromNumberOrString: intFromNumberOrString,
  floatFromString: floatFromString,
  floatFromNumberOrString: floatFromNumberOrString,
  parseStringToJson: parseStringToJson
};

var include = Relude_Result.WithError({});

var Alt = include.Alt;

var Infix = include.Infix;

function note(failure) {
  var partial_arg = Relude_Result.error(failure);
  return function (param) {
    return Option$BsBastet.maybe(Relude_Result.ok, partial_arg, param);
  };
}

var ResultUtil_Functor = include.Functor;

var ResultUtil_map = include.map;

var ResultUtil_BsFunctorExtensions = include.BsFunctorExtensions;

var ResultUtil_flipMap = include.flipMap;

var ResultUtil_void = include.$$void;

var ResultUtil_voidRight = include.voidRight;

var ResultUtil_voidLeft = include.voidLeft;

var ResultUtil_flap = include.flap;

var ResultUtil_alt = include.alt;

var ResultUtil_orElse = include.orElse;

var ResultUtil_Apply = include.Apply;

var ResultUtil_apply = include.apply;

var ResultUtil_BsApplyExtensions = include.BsApplyExtensions;

var ResultUtil_applyFirst = include.applyFirst;

var ResultUtil_applySecond = include.applySecond;

var ResultUtil_map2 = include.map2;

var ResultUtil_map3 = include.map3;

var ResultUtil_map4 = include.map4;

var ResultUtil_map5 = include.map5;

var ResultUtil_tuple2 = include.tuple2;

var ResultUtil_tuple3 = include.tuple3;

var ResultUtil_tuple4 = include.tuple4;

var ResultUtil_tuple5 = include.tuple5;

var ResultUtil_mapTuple2 = include.mapTuple2;

var ResultUtil_mapTuple3 = include.mapTuple3;

var ResultUtil_mapTuple4 = include.mapTuple4;

var ResultUtil_mapTuple5 = include.mapTuple5;

var ResultUtil_Applicative = include.Applicative;

var ResultUtil_pure = include.pure;

var ResultUtil_BsApplicativeExtensions = include.BsApplicativeExtensions;

var ResultUtil_liftA1 = include.liftA1;

var ResultUtil_Semialign = include.Semialign;

var ResultUtil_Monad = include.Monad;

var ResultUtil_bind = include.bind;

var ResultUtil_BsMonadExtensions = include.BsMonadExtensions;

var ResultUtil_flatMap = include.flatMap;

var ResultUtil_flatten = include.flatten;

var ResultUtil_composeKleisli = include.composeKleisli;

var ResultUtil_flipComposeKleisli = include.flipComposeKleisli;

var ResultUtil_liftM1 = include.liftM1;

var ResultUtil_when_ = include.when_;

var ResultUtil_unless = include.unless;

var ResultUtil_MonadThrow = include.MonadThrow;

var ResultUtil_throwError = include.throwError;

var ResultUtil_MonadError = include.MonadError;

var ResultUtil_catchError = include.catchError;

var ResultUtil_Semigroupoid = include.Semigroupoid;

var ResultUtil_compose = include.compose;

var ResultUtil_andThen = include.andThen;

var ResultUtil_Foldable = include.Foldable;

var ResultUtil_foldLeft = include.foldLeft;

var ResultUtil_foldRight = include.foldRight;

var ResultUtil_BsFoldableExtensions = include.BsFoldableExtensions;

var ResultUtil_any = include.any;

var ResultUtil_all = include.all;

var ResultUtil_containsBy = include.containsBy;

var ResultUtil_contains = include.contains;

var ResultUtil_indexOfBy = include.indexOfBy;

var ResultUtil_indexOf = include.indexOf;

var ResultUtil_minBy = include.minBy;

var ResultUtil_min = include.min;

var ResultUtil_maxBy = include.maxBy;

var ResultUtil_max = include.max;

var ResultUtil_countBy = include.countBy;

var ResultUtil_length = include.length;

var ResultUtil_size = include.size;

var ResultUtil_count = include.count;

var ResultUtil_forEach = include.forEach;

var ResultUtil_forEachWithIndex = include.forEachWithIndex;

var ResultUtil_find = include.find;

var ResultUtil_findWithIndex = include.findWithIndex;

var ResultUtil_toList = include.toList;

var ResultUtil_toArray = include.toArray;

var ResultUtil_FoldableSemigroupExtensions = include.FoldableSemigroupExtensions;

var ResultUtil_FoldableMonoidExtensions = include.FoldableMonoidExtensions;

var ResultUtil_foldMap = include.foldMap;

var ResultUtil_foldWithMonoid = include.foldWithMonoid;

var ResultUtil_intercalate = include.intercalate;

var ResultUtil_FoldableApplicativeExtensions = include.FoldableApplicativeExtensions;

var ResultUtil_FoldableMonadExtensions = include.FoldableMonadExtensions;

var ResultUtil_FoldableEqExtensions = include.FoldableEqExtensions;

var ResultUtil_FoldableOrdExtensions = include.FoldableOrdExtensions;

var ResultUtil_WithApplicative = include.WithApplicative;

var ResultUtil_Eq = include.Eq;

var ResultUtil_Ord = include.Ord;

var ResultUtil_Show = include.Show;

var ResultUtil = {
  Functor: ResultUtil_Functor,
  map: ResultUtil_map,
  BsFunctorExtensions: ResultUtil_BsFunctorExtensions,
  flipMap: ResultUtil_flipMap,
  $$void: ResultUtil_void,
  voidRight: ResultUtil_voidRight,
  voidLeft: ResultUtil_voidLeft,
  flap: ResultUtil_flap,
  Alt: Alt,
  alt: ResultUtil_alt,
  orElse: ResultUtil_orElse,
  Apply: ResultUtil_Apply,
  apply: ResultUtil_apply,
  BsApplyExtensions: ResultUtil_BsApplyExtensions,
  applyFirst: ResultUtil_applyFirst,
  applySecond: ResultUtil_applySecond,
  map2: ResultUtil_map2,
  map3: ResultUtil_map3,
  map4: ResultUtil_map4,
  map5: ResultUtil_map5,
  tuple2: ResultUtil_tuple2,
  tuple3: ResultUtil_tuple3,
  tuple4: ResultUtil_tuple4,
  tuple5: ResultUtil_tuple5,
  mapTuple2: ResultUtil_mapTuple2,
  mapTuple3: ResultUtil_mapTuple3,
  mapTuple4: ResultUtil_mapTuple4,
  mapTuple5: ResultUtil_mapTuple5,
  Applicative: ResultUtil_Applicative,
  pure: ResultUtil_pure,
  BsApplicativeExtensions: ResultUtil_BsApplicativeExtensions,
  liftA1: ResultUtil_liftA1,
  Semialign: ResultUtil_Semialign,
  Monad: ResultUtil_Monad,
  bind: ResultUtil_bind,
  BsMonadExtensions: ResultUtil_BsMonadExtensions,
  flatMap: ResultUtil_flatMap,
  flatten: ResultUtil_flatten,
  composeKleisli: ResultUtil_composeKleisli,
  flipComposeKleisli: ResultUtil_flipComposeKleisli,
  liftM1: ResultUtil_liftM1,
  when_: ResultUtil_when_,
  unless: ResultUtil_unless,
  MonadThrow: ResultUtil_MonadThrow,
  throwError: ResultUtil_throwError,
  MonadError: ResultUtil_MonadError,
  catchError: ResultUtil_catchError,
  Semigroupoid: ResultUtil_Semigroupoid,
  compose: ResultUtil_compose,
  andThen: ResultUtil_andThen,
  Foldable: ResultUtil_Foldable,
  foldLeft: ResultUtil_foldLeft,
  foldRight: ResultUtil_foldRight,
  BsFoldableExtensions: ResultUtil_BsFoldableExtensions,
  any: ResultUtil_any,
  all: ResultUtil_all,
  containsBy: ResultUtil_containsBy,
  contains: ResultUtil_contains,
  indexOfBy: ResultUtil_indexOfBy,
  indexOf: ResultUtil_indexOf,
  minBy: ResultUtil_minBy,
  min: ResultUtil_min,
  maxBy: ResultUtil_maxBy,
  max: ResultUtil_max,
  countBy: ResultUtil_countBy,
  length: ResultUtil_length,
  size: ResultUtil_size,
  count: ResultUtil_count,
  forEach: ResultUtil_forEach,
  forEachWithIndex: ResultUtil_forEachWithIndex,
  find: ResultUtil_find,
  findWithIndex: ResultUtil_findWithIndex,
  toList: ResultUtil_toList,
  toArray: ResultUtil_toArray,
  FoldableSemigroupExtensions: ResultUtil_FoldableSemigroupExtensions,
  FoldableMonoidExtensions: ResultUtil_FoldableMonoidExtensions,
  foldMap: ResultUtil_foldMap,
  foldWithMonoid: ResultUtil_foldWithMonoid,
  intercalate: ResultUtil_intercalate,
  FoldableApplicativeExtensions: ResultUtil_FoldableApplicativeExtensions,
  FoldableMonadExtensions: ResultUtil_FoldableMonadExtensions,
  FoldableEqExtensions: ResultUtil_FoldableEqExtensions,
  FoldableOrdExtensions: ResultUtil_FoldableOrdExtensions,
  WithApplicative: ResultUtil_WithApplicative,
  Eq: ResultUtil_Eq,
  Ord: ResultUtil_Ord,
  Show: ResultUtil_Show,
  Infix: Infix,
  note: note
};

var include$1 = Relude_Extensions_Alt.AltInfix(Alt);

var $less$pipe$great$1 = include$1.$less$pipe$great;

function jsonDateToDate(json) {
  if (isValidDate(json)) {
    return Relude_Option.pure(json);
  }
  
}

function toDate$1(maybeDate) {
  return Relude_Option.fold(Relude_Result.error({
                  TAG: /* Val */0,
                  _0: "ExpectedValidDate",
                  _1: maybeDate
                }), Relude_Result.ok, jsonDateToDate(maybeDate));
}

function date$1(json) {
  return Curry._2($less$pipe$great$1, Curry._2($less$pipe$great$1, Curry._2($less$pipe$great$1, Curry._1(Decode_AsResult_OfParseError.date, json), toDate$1(json)), Relude_Result.fromOption({
                      TAG: /* Val */0,
                      _0: "ExpectedValidDate",
                      _1: json
                    }, infinityToMaxDate(json))), Relude_Result.fromOption({
                  TAG: /* Val */0,
                  _0: "ExpectedValidDate",
                  _1: json
                }, negativeInfinityToMinDate(json)));
}

function intFromString$1(json) {
  var partial_arg = {
    TAG: /* Val */0,
    _0: "ExpectedInt",
    _1: json
  };
  var partial_arg$1 = function (param) {
    return Relude_Result.fromOption(partial_arg, param);
  };
  return Relude_Result.flatMap((function (param) {
                return Relude_Globals.$great$great(Relude_String.toInt, partial_arg$1, param);
              }), Curry._1(Decode_AsResult_OfParseError.string, json));
}

function intFromNumberOrString$1(json) {
  return Curry._2($less$pipe$great$1, Curry._1(Decode_AsResult_OfParseError.intFromNumber, json), intFromString$1(json));
}

function floatFromString$1(json) {
  var partial_arg = {
    TAG: /* Val */0,
    _0: "ExpectedInt",
    _1: json
  };
  var partial_arg$1 = function (param) {
    return Relude_Result.fromOption(partial_arg, param);
  };
  return Relude_Result.flatMap((function (param) {
                return Relude_Globals.$great$great(Relude_String.toFloat, partial_arg$1, param);
              }), Curry._1(Decode_AsResult_OfParseError.string, json));
}

function floatFromNumberOrString$1(json) {
  return Curry._2($less$pipe$great$1, Curry._1(Decode_AsResult_OfParseError.floatFromNumber, json), floatFromString$1(json));
}

function parseStringToJson$1(str) {
  try {
    return Relude_Result.ok(JSON.parse(str));
  }
  catch (_exn){
    return Relude_Result.error({
                TAG: /* Val */0,
                _0: "ExpectedValidOption",
                _1: null
              });
  }
}

function mapErrorToDebugString(result) {
  return Curry._2(Relude_Result.mapError, Decode_ParseError.failureToDebugString, result);
}

var Decode_FunctorExtensions = Infix.FunctorExtensions;

var Decode_$less$dollar$great = Infix.$less$$great;

var Decode_$less$hash$great = Infix.$less$hash$great;

var Decode_$less$dollar = Infix.$less$;

var Decode_$$great = Infix.$$great;

var Decode_$less$at$great = Infix.$less$at$great;

var Decode_$less$less$dollar$great$great = Infix.$less$less$$great$great;

var Decode_ApplyExtensions = Infix.ApplyExtensions;

var Decode_$less$star$great = Infix.$less$star$great;

var Decode_$less$star = Infix.$less$star;

var Decode_$star$great = Infix.$star$great;

var Decode_MonadExtensions = Infix.MonadExtensions;

var Decode_$great$great$eq = Infix.$great$great$eq;

var Decode_$eq$less$less = Infix.$eq$less$less;

var Decode_$great$eq$great = Infix.$great$eq$great;

var Decode_$less$eq$less = Infix.$less$eq$less;

var Decode_SE = Infix.SE;

var Decode_$less$less$less = Infix.$less$less$less;

var Decode_$great$great$great = Infix.$great$great$great;

var Decode = {
  $$Option: $$Option,
  NonEmptyList: Decode_AsResult_OfParseError.NonEmptyList,
  ParseError: Decode_AsResult_OfParseError.ParseError,
  map: Decode_AsResult_OfParseError.map,
  apply: Decode_AsResult_OfParseError.apply,
  map2: Decode_AsResult_OfParseError.map2,
  map3: Decode_AsResult_OfParseError.map3,
  map4: Decode_AsResult_OfParseError.map4,
  map5: Decode_AsResult_OfParseError.map5,
  pure: Decode_AsResult_OfParseError.pure,
  flatMap: Decode_AsResult_OfParseError.flatMap,
  alt: Decode_AsResult_OfParseError.alt,
  okJson: Decode_AsResult_OfParseError.okJson,
  $$boolean: Decode_AsResult_OfParseError.$$boolean,
  string: Decode_AsResult_OfParseError.string,
  floatFromNumber: Decode_AsResult_OfParseError.floatFromNumber,
  intFromNumber: Decode_AsResult_OfParseError.intFromNumber,
  variantFromJson: Decode_AsResult_OfParseError.variantFromJson,
  variantFromString: Decode_AsResult_OfParseError.variantFromString,
  variantFromInt: Decode_AsResult_OfParseError.variantFromInt,
  optional: Decode_AsResult_OfParseError.optional,
  array: Decode_AsResult_OfParseError.array,
  list: Decode_AsResult_OfParseError.list,
  tuple: Decode_AsResult_OfParseError.tuple,
  tuple2: Decode_AsResult_OfParseError.tuple2,
  tuple3: Decode_AsResult_OfParseError.tuple3,
  tuple4: Decode_AsResult_OfParseError.tuple4,
  tuple5: Decode_AsResult_OfParseError.tuple5,
  tupleAtLeast2: Decode_AsResult_OfParseError.tupleAtLeast2,
  tupleAtLeast3: Decode_AsResult_OfParseError.tupleAtLeast3,
  tupleAtLeast4: Decode_AsResult_OfParseError.tupleAtLeast4,
  tupleAtLeast5: Decode_AsResult_OfParseError.tupleAtLeast5,
  tupleFromFields: Decode_AsResult_OfParseError.tupleFromFields,
  dict: Decode_AsResult_OfParseError.dict,
  stringMap: Decode_AsResult_OfParseError.stringMap,
  at: Decode_AsResult_OfParseError.at,
  field: Decode_AsResult_OfParseError.field,
  optionalField: Decode_AsResult_OfParseError.optionalField,
  fallback: Decode_AsResult_OfParseError.fallback,
  oneOf: Decode_AsResult_OfParseError.oneOf,
  Pipeline: Decode_AsResult_OfParseError.Pipeline,
  ResultUtil: ResultUtil,
  FunctorExtensions: Decode_FunctorExtensions,
  $less$$great: Decode_$less$dollar$great,
  $less$hash$great: Decode_$less$hash$great,
  $less$: Decode_$less$dollar,
  $$great: Decode_$$great,
  $less$at$great: Decode_$less$at$great,
  $less$less$$great$great: Decode_$less$less$dollar$great$great,
  ApplyExtensions: Decode_ApplyExtensions,
  $less$star$great: Decode_$less$star$great,
  $less$star: Decode_$less$star,
  $star$great: Decode_$star$great,
  MonadExtensions: Decode_MonadExtensions,
  $great$great$eq: Decode_$great$great$eq,
  $eq$less$less: Decode_$eq$less$less,
  $great$eq$great: Decode_$great$eq$great,
  $less$eq$less: Decode_$less$eq$less,
  SE: Decode_SE,
  $less$less$less: Decode_$less$less$less,
  $great$great$great: Decode_$great$great$great,
  $less$pipe$great: $less$pipe$great$1,
  jsonDateToDate: jsonDateToDate,
  toDate: toDate$1,
  date: date$1,
  intFromString: intFromString$1,
  intFromNumberOrString: intFromNumberOrString$1,
  floatFromString: floatFromString$1,
  floatFromNumberOrString: floatFromNumberOrString$1,
  ok: Relude_Result.ok,
  parseStringToJson: parseStringToJson$1,
  mapErrorToDebugString: mapErrorToDebugString
};

function $$char(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (prim) {
                              return prim;
                            }), Relude_String.fromCharCode, param);
              }), (function (prim) {
                return prim;
              }), param);
}

function date$2(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.toJSON();
              }), (function (prim) {
                return prim;
              }), param);
}

function optional(encode, v) {
  if (v !== undefined) {
    return Curry._1(encode, Caml_option.valFromOption(v));
  } else {
    return null;
  }
}

function withDefault(d, encode, v) {
  if (v !== undefined) {
    return Curry._1(encode, Caml_option.valFromOption(v));
  } else {
    return d;
  }
}

function object_(param) {
  return Relude_Globals.$great$great(Js_dict.fromList, (function (prim) {
                return prim;
              }), param);
}

function array(encode) {
  var partial_arg = Curry._1(Relude_Array.map, encode);
  return function (param) {
    return Relude_Globals.$great$great(partial_arg, (function (prim) {
                  return prim;
                }), param);
  };
}

function list(encode) {
  var partial_arg = Curry._1(Relude_Array.map, encode);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$great$great(partial_arg, (function (prim) {
                  return prim;
                }), param);
  };
  return function (param) {
    return Relude_Globals.$great$great(Relude_List.toArray, partial_arg$1, param);
  };
}

function pair(encodeA, encodeB, param) {
  return [
          Curry._1(encodeA, param[0]),
          Curry._1(encodeB, param[1])
        ];
}

function tuple3(encodeA, encodeB, encodeC, param) {
  return [
          Curry._1(encodeA, param[0]),
          Curry._1(encodeB, param[1]),
          Curry._1(encodeC, param[2])
        ];
}

function tuple4(encodeA, encodeB, encodeC, encodeD, param) {
  return [
          Curry._1(encodeA, param[0]),
          Curry._1(encodeB, param[1]),
          Curry._1(encodeC, param[2]),
          Curry._1(encodeD, param[3])
        ];
}

function encodeAny(x) {
  return Relude_Option.getOrElse(null, Curry._2(Relude_Option.flatMap, (function (str) {
                    try {
                      return Caml_option.some(JSON.parse(str));
                    }
                    catch (_exn){
                      return ;
                    }
                  }), JSON.stringify(x)));
}

var Encode = {
  $$char: $$char,
  date: date$2,
  optional: optional,
  withDefault: withDefault,
  object_: object_,
  array: array,
  arrayOf: array,
  list: list,
  pair: pair,
  tuple2: pair,
  tuple3: tuple3,
  tuple4: tuple4,
  encodeAny: encodeAny
};

function getEmpty(param) {
  return Relude_Globals.$great$great((function (prim) {
                return {};
              }), (function (prim) {
                return prim;
              }), param);
}

var ParseError;

exports.ParseError = ParseError;
exports.Decode = Decode;
exports.Encode = Encode;
exports.getEmpty = getEmpty;
/* partial_arg Not a pure module */
